import { Button } from '@ets-global/b2c-website-ui';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import useRouter from '../../hooks/useRouter';
import { paths } from '../../paths';

const SessionSearchBlock = () => {
  const location = useLocation();
  const { currentRoute } = useRouter();
  const { t } = useTranslation();

  return (
    <div className={'footer__row footer__row--third'}>
      <p className={'footer__title'}>
        <Trans>footer.session_search.title</Trans>
      </p>
      <Button
        to={currentRoute.path === paths.SESSION_SEARCH ? location.pathname : paths.SESSION_SEARCH}
        search={currentRoute.path === paths.SESSION_SEARCH ? location.search : null}
        aria-label={t('footer.session_search.button')}
      >
        <Trans>footer.session_search.button</Trans>
      </Button>
    </div>
  );
};

export default SessionSearchBlock;
